import React from 'react';
import { GIButton, Modal } from 'app-components';
import styled from 'styled-components';

const StyledModalBody = styled.div`
    .gi-modal__content {
        width: 30% !important;
        padding-bottom: 0px;
    }
    .template-form__input {
        margin-bottom:0 !important;
    }
`;
interface IResultDialogProps {
    message: string,
    headerId: string,
    onClose: () => void
}

const ResultDialog = (props: IResultDialogProps) => {
    const { message, headerId, onClose } = props;
    return (
        <StyledModalBody>
            <Modal id={`result-dialog-${headerId}`}>
                <Modal.Header
                    id={`result-dialog-title-${headerId}`}
                    titleId={headerId}
                    onHide={onClose}
                />
                <Modal.Body>
                    <div>{message}</div>
                </Modal.Body>
                <Modal.Controls>
                    <div>
                        <GIButton
                            id={`result-dialog-title-${headerId}`}
                            labelId={'dashboard.ok'}
                            onClickHandler={onClose}
                        />
                    </div>
                </Modal.Controls>
            </Modal>
        </StyledModalBody>
    );
};
export default ResultDialog;
